import React from 'react';
import AllWorkListTable from './allWorkListTable';

const SentForApproval = () => {
  return (
<AllWorkListTable type="sent"/>
  )
}

export default SentForApproval